module.exports = __webpack_public_path__ + "static/img/rank2.3d358bb.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank/rank2.webp
// module id = LjCL
// module chunks = 0